import { render, staticRenderFns } from "./ModalAddVideo.vue?vue&type=template&id=5fc9ac0b&"
import script from "./ModalAddVideo.vue?vue&type=script&lang=js&"
export * from "./ModalAddVideo.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports